import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { flatMap, map, skip, take } from 'rxjs/operators';
import { isEmpty, isNull } from 'lodash';
import { AccountDispatcher, AccountStore } from '../store';
import {
  ISetPasswordToken,
  LEGACY_SET_PASSWORD_TOKEN_PARAMETER_KEY,
  SET_PASSWORD_TOKEN_PARAMETER_KEY,
} from '../account.data';
import { LocalizationStore } from '../../localization/store/stores';

@Injectable()
export class SetPasswordTokenGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _accountStore: AccountStore,
    private _accountDispatchers: AccountDispatcher,
    private _localizationStore: LocalizationStore
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | UrlTree {
    // TODO: remove support for legacy token
    const token =
      route.queryParamMap.get(SET_PASSWORD_TOKEN_PARAMETER_KEY) ||
      route.queryParamMap.get(LEGACY_SET_PASSWORD_TOKEN_PARAMETER_KEY);

    if (!isEmpty(token)) {
      return this._localizationStore.getCurrentLocale().pipe(
        take(1),
        flatMap((locale: string) => {
          this._accountDispatchers.setPasswordToken(token, locale);

          return this._accountStore.getSetPasswordToken(); // get token
        }),
        skip(1),
        take(1),
        map(
          (setToken: ISetPasswordToken) =>
            !isNull(setToken) || this._router.parseUrl('/login')
        )
      );
    }

    return this._router.parseUrl('/login');
  }
}
